import { Injectable } from '@angular/core';
// Store
import { Selector, State, StateContext, Action } from '@ngxs/store';
// State
import { InboxState } from '../inbox/state/inbox.state';
import { ImportState } from '../import-order/state/import.state';
// Models
import { CI_STATE_PATH, IntelligenceStateModel } from './model/intelligence-state.model';
import { SetOrderIsImporter } from './actions/intelligence.actions';

@State<IntelligenceStateModel>({
	name: CI_STATE_PATH,
	defaults: new IntelligenceStateModel(),
	children: [InboxState, ImportState]
})
@Injectable()
export class IntelligenceState {
	constructor() {
		//
	}

	/**
	 * Get Feature Intelligence State Model.
	 * @param state: IntelligenceStateModel
	 */
	@Selector()
	static getIntelligence(state: IntelligenceStateModel): IntelligenceStateModel {
		return state;
	}

	/**
	 * Get if an order was imported manually
	 * @param state: IntelligenceStateModel
	 */
	@Selector()
	static getOrderIsImported(state: IntelligenceStateModel): boolean {
		return state.isOrderImporter;
	}

	/**
	 * Save the if an order was imported manually
	 * @param ctx
	 * @param isOrderImporter
	 */
	@Action(SetOrderIsImporter)
	setOrderIsImporter(
		ctx: StateContext<IntelligenceStateModel>,
		{ isOrderImporter }: SetOrderIsImporter
	): any {
		ctx.patchState({
			isOrderImporter
		});
	}
}
